<script>
      /* eslint-disable */ 

</script>

<template>
    <div class="margin">
        <div class="row tit_page">
			<div class="col-12">
				<div class="float-left">
					<h1>Documentos</h1>
				</div>
				<div class="back float-right">
					<a @click="$router.go(-1)" href="javascript:;" title="Voltar">
						<i>&nbsp;</i> voltar
					</a>
				</div>
				<div class="clearfix"></div>
			</div>
        </div>
        <hr class="divider">
        <div class="row">
            <div class="col-12">
                <div class="box-td">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" class="align-middle text-left">
                                        Nome
                                    </th>
                                    <th scope="col" class="align-middle text-left">
                                        Documento
                                    </th>
                                    <th scope="col" class="align-middle text-center">
                                        Enviado
                                    </th>
                                    <th scope="col" class="align-middle text-center">
                                        &nbsp;
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="response">
                                <tr v-for="identidade in arquivosIdentidade" :key="identidade.Nome">
                                    <td class="align-middle text-left">
                                        <i v-if="identidade.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="identidade.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{ nomeArquivo(identidade.MetaDados.NomeArquivo) }} 
                                        <span v-if="identidade.Status == '' || identidade.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="identidade.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>
                                    <td class="align-middle text-left">
                                        Identidade
                                    </td>
                                    <td class="align-middle text-center">
                                        {{ formatDate(identidade) }}
                                    </td>
                                    <td class="align-middle text-center">
                                        <a v-if="identidade.Status != 'APROVADO'" id="show-modal" @click="exibeModal(identidade, 'Identidade', 'ArquivosIdentidade')" class="td-link">
                                            <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a>
                                        <a v-bind:href="uploadEndpoint + identidade.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>
                                    </td>
                                </tr>
                                <tr v-for="endereco in arquivosComprovanteResidencia" :key="endereco.Nome">
                                    <td class="align-middle text-left">
                                        <i v-if="endereco.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="endereco.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>  
                                        {{ nomeArquivo(endereco.MetaDados.NomeArquivo) }}
                                        <span v-if="endereco.Status == '' || endereco.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="endereco.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>
                                    <td class="align-middle text-left">
                                        Comprovante de Residência
                                    </td>
                                    <td class="align-middle text-center">
                                        {{ formatDate(endereco) }}
                                    </td>
                                    <td class="align-middle text-center">
                                        <a v-if="endereco.Status != 'APROVADO'" id="show-modal" @click="exibeModal(endereco, 'Comprovante de Residência', 'ArquivosComprovanteResidencia')" class="td-link">
                                            <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                        <a v-bind:href="uploadEndpoint + endereco.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showModal" class="modal-invited" @close="closeModal()">
            <div slot="header">
                <div class="tit float-left">
                    <h2 style="padding-right:50px;"><i class="icon icon-airplane xl"></i> Enviar {{ tipoArquivoSelecionado }}</h2>
                </div>
            </div>
            <div slot="body" style="overflow-x: auto;">
                <!-- documento enviado com sucesso -->
                <div v-if="submitted" class="success d-flex flex-column justify-content-center align-items-center">
                    <i class="icon icon-success xll"></i>
                    <h3>Documento enviado com sucesso!</h3>
                </div>
                <!-- ***************************** -->
                <div v-else>
                    <files-input :files="files" :accept="acceptedFormats"
                        :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
                    <br />
                    <div class="float-md-right">
                        <button class="btn btn-primary" style="color: #fff !important;"  @click="submit()">Enviar Documentos</button>            
                    </div>
                </div>
                <br/> 
            </div>
        </modal>  
    </div>
</template>

<style lang="scss" scoped>
    @import "../../assets/styles/iouu/mixins";
    @import "../../assets/styles/iouu/list-documents";

    @include xs {
        .btn-exit{
            position: absolute;
            top: 2px!important;
            right: 2px!important;
        }
        .btn {
            width: 100%;
        }
    }

</style>

<script>
    import ApiClient from '../../utils/api-client';
    import Modal from '@/components/Modal'
    import FilesInput from '@/components/FilesInput'

    export default {
        components: { Modal, FilesInput },
        data() {
            return {
                response: false,
                showModal: false,
                submitted: false,
                created: {},
                arquivosIdentidade: {},
                arquivosComprovanteResidencia: {},
                tipoArquivoSelecionado: "",
                /* eslint-disable */ 
                uploadEndpoint: process.env.API_NODE+'/files',
                acceptedFormats: 'application/pdf, image/jpeg, image/png',
                files: [null]
            }
        },
        methods: {
            formatDate(documento) {
                let data
                documento.DataEnvio == null ? data = documento.MetaDados.UltimaModificacao : data = documento.DataEnvio
                let dataForm = new Date(data);
                let dia = dataForm.getDate();

                if (dia.toString().length == 1)
                    dia = "0" + dia;

                let mes = dataForm.getMonth() + 1;

                if (mes.toString().length == 1)
                    mes = "0" + mes;

                let ano = dataForm.getFullYear();

                if(isNaN(parseInt(ano))|| isNaN(parseInt(mes)) || isNaN(parseInt(dia))) {
                    
                    return this.formatDate(this.created);
                }

                return dia + "/" + mes + "/" + ano;
            },

            exibeModal(arquivo, tipoArquivoSelecionado, campoNome) {
                this.files = [null];
                this.submitted = false;                
                this.showModal = true;

                this.tipoArquivoSelecionado = tipoArquivoSelecionado;
                this.nomeArquivoSelecionado = arquivo.Nome;
                this.campoArquivoMongodb = campoNome;

                if(document.getElementsByTagName("main").length > 0 ){
                     document.getElementsByTagName("main")[0].style.zIndex = "50";
                }
            },

            onFilesChanged(updatedFiles) {
                this.files = updatedFiles
            },

            removeFile(index) {
                this.files.splice(index, 1)
            },

            clearFile(index) {
                this.$set(this.files, index, null)
            },

            validate() {
                if(this.receivedFiles.length > 0) {
                    return {isValid: true, errors: []}
                } else {
                    return {isValid: false, errors: ['O envio do documento de identidade é obrigatório']}
                }
            },

            submit() {
                this.submitted = true;

                ApiClient.createDocumentos(this.getType, this.campoArquivoMongodb, this.getId, this.nomeArquivoSelecionado,  this.receivedFiles)
                    .then(() => { });
            },

            closeModal() {
                this.showModal = false;
                
                ApiClient.getDocumentos(this.getType, this.getId)
                    .then(response => {
                        this.arquivosComprovanteResidencia = response.data.ArquivosComprovanteResidencia;
                        this.arquivosIdentidade = response.data.ArquivosIdentidade;
                        this.created = response.data.Created;
                        this.response = true;
                    });
                    if(document.getElementsByTagName("main").length > 0 ){
                        document.getElementsByTagName("main")[0].style.zIndex = "0";
                    }
            },
            
        nomeArquivo(arquivo){
            if(arquivo.length > 22){
                var extensao = arquivo.substr(arquivo.lastIndexOf("."))
                var nome = arquivo.substr(0,arquivo.lastIndexOf("."))

                return nome.substr(0,15)+"..." + extensao;

            }

            return arquivo;
        }
        },
        props: ['type', 'id'],

        created() {

            ApiClient.getDocumentos(this.getType, this.getId)
            .then(response => {
                // console.log(JSON.stringify(response,null,2))
                this.arquivosComprovanteResidencia = response.data.ArquivosComprovanteResidencia;
                this.arquivosIdentidade = response.data.ArquivosIdentidade;
                        this.created = response.data.Created;
                this.response = true;
            });
        },

        computed: {
            getType() {
                return this.type;
            },

            getId() {
                return this.id;
            },

            receivedFiles() {
                return this.files.filter(file => {
                    return file != null && file != undefined
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Documentos/DocumentosInvestidor.vue